module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_askersund-0d1ad1e863d92e321707850353318f2e.png";